// extracted by mini-css-extract-plugin
export default {"formInputLabel":"FormInput_formInputLabel__S9MT9","formInput":"FormInput_formInput__Tr8Xc","formInputErrorText":"FormInput_formInputErrorText__Dpb7n"};